// // import React, { useState } from "react";
// // import { useFormik } from "formik";
// // import * as Yup from "yup";
// // import {
// //   Box,
// //   TextField,
// //   Button,
// //   Typography,
// //   CircularProgress,
// //   Link,
// // } from "@mui/material";
// // import axios from "axios";
// // import { API_BASE_URL } from "../../config";
// // import { SnackBarComponent } from "../../Components/snackBar/snackBar";

// // export const ForgotPassword = ({ onReset, onBackToLogin }) => {
// //   const [loading, setLoading] = useState(false);
// //   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

// //   const formik = useFormik({
// //     initialValues: { email: "" },
// //     validationSchema: Yup.object({
// //       email: Yup.string().email("Invalid email").required("Required"),
// //     }),
// //     onSubmit: async (values) => {
// //       setLoading(true);
// //       try {
// //         await axios.post(`${API_BASE_URL}/auth/forgot-pass/`, { email: values.email });
// //         setSnackbar({ open: true, message: "OTP sent! Check your email.", severity: "success" });
// //         setTimeout(() => {
// //           setSnackbar({ open: false });
// //           onReset(values.email); // Go to reset form, pass email
// //         }, 1200);
// //       } catch (err) {
// //         setSnackbar({
// //           open: true,
// //           message: err?.response?.data?.message || "Failed to send OTP",
// //           severity: "error",
// //         });
// //       } finally {
// //         setLoading(false);
// //       }
// //     },
// //   });

// //   const handleCloseSnackbar = (_, reason) => {
// //     if (reason === "clickaway") return;
// //     setSnackbar((s) => ({ ...s, open: false }));
// //   };

// //   return (
// //     <>
// //       <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center">
// //         Forgot Password
// //       </Typography>

// //       <Box
// //         component="form"
// //         onSubmit={formik.handleSubmit}
// //         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
// //       >
// //         <TextField
// //           label="Email"
// //           name="email"
// //           size="small"
// //           value={formik.values.email}
// //           onChange={formik.handleChange}
// //           onBlur={formik.handleBlur}
// //           error={formik.touched.email && Boolean(formik.errors.email)}
// //           helperText={formik.touched.email && formik.errors.email}
// //           fullWidth
// //           required
// //         />

// //         <Button
// //           type="submit"
// //           variant="contained"
// //           fullWidth
// //           disabled={loading}
// //           startIcon={loading ? <CircularProgress size={20} /> : null}
// //         >
// //           {loading ? "Sending..." : "Send OTP"}
// //         </Button>

// //         <Typography variant="body2" align="center" sx={{ mt: 1 }}>
// //           <Link underline="hover" sx={{ cursor: "pointer" }} onClick={onBackToLogin}>
// //             Back to Login
// //           </Link>
// //         </Typography>
// //       </Box>

// //       {/* Custom Snackbar */}
// //       <SnackBarComponent
// //         open={snackbar.open}
// //         message={snackbar.message}
// //         severity={snackbar.severity}
// //         onClose={handleCloseSnackbar}
// //       />
// //     </>
// //   );
// // };



// import React, { useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   CircularProgress,
//   Link,
// } from "@mui/material";
// import axios from "axios";
// import { API_BASE_URL } from "../../config";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { useTranslation } from "react-i18next";

// export const ForgotPassword = ({ onReset, onBackToLogin }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const formik = useFormik({
//     initialValues: { email: "" },
//     validationSchema: Yup.object({
//       email: Yup.string()
//         .email(t("forgot.errors.invalidEmail"))
//         .required(t("forgot.errors.required")),
//     }),
//     onSubmit: async (values) => {
//       setLoading(true);
//       try {
//         await axios.post(`${API_BASE_URL}/auth/forgot-pass/`, {
//           email: values.email,
//         });
//         setSnackbar({
//           open: true,
//           message: t("forgot.success"),
//           severity: "success",
//         });
//         setTimeout(() => {
//           setSnackbar({ open: false });
//           onReset(values.email); // Go to reset form, pass email
//         }, 1200);
//       } catch (err) {
//         setSnackbar({
//           open: true,
//           message:
//             err?.response?.data?.message || t("forgot.errors.failure"),
//           severity: "error",
//         });
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   const handleCloseSnackbar = (_, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbar((s) => ({ ...s, open: false }));
//   };

//   return (
//     <>
//       <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center">
//         {t("forgot.heading")}
//       </Typography>

//       <Box
//         component="form"
//         onSubmit={formik.handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         <TextField
//           label={t("forgot.fields.email")}
//           name="email"
//           size="small"
//           value={formik.values.email}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.email && Boolean(formik.errors.email)}
//           helperText={formik.touched.email && formik.errors.email}
//           fullWidth
//           required
//         />

//         <Button
//           type="submit"
//           variant="contained"
//           fullWidth
//           disabled={loading}
//           startIcon={loading ? <CircularProgress size={20} /> : null}
//         >
//           {loading ? t("forgot.buttons.sending") : t("forgot.buttons.sendOtp")}
//         </Button>

//         <Typography variant="body2" align="center" sx={{ mt: 1 }}>
//           <Link
//             underline="hover"
//             sx={{ cursor: "pointer" }}
//             onClick={onBackToLogin}
//           >
//             {t("forgot.backToLogin")}
//           </Link>
//         </Typography>
//       </Box>

//       {/* Custom Snackbar */}
//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={handleCloseSnackbar}
//       />
//     </>
//   );
// };



import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Link,
} from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { CaptchaComponent } from "../../Components/captcha/captchaComponent";
import { useTranslation } from "react-i18next";

export const ForgotPassword = ({ onReset, onBackToLogin }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [captchaKey, setCaptchaKey] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const formik = useFormik({
    initialValues: { email: "", captcha_value: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t("forgot.errors.invalidEmail"))
        .required(t("forgot.errors.required")),
      captcha_value: Yup.string().required(t("signin.errors.captchaRequired")),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await axios.post(`${API_BASE_URL}/auth/forgot-pass/`, {
          email: values.email,
          captcha_key: captchaKey,
          captcha_value: values.captcha_value,
        });
        setSnackbar({
          open: true,
          message: t("forgot.success"),
          severity: "success",
        });
        setTimeout(() => {
          setSnackbar({ open: false });
          onReset(values.email); // Go to reset form, pass email
        }, 1200);
      } catch (err) {
        setSnackbar({
          open: true,
          message:
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            t("forgot.errors.failure"),
          severity: "error",
        });
        formik.setFieldValue("captcha_value", "");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((s) => ({ ...s, open: false }));
  };

  return (
    <>
      <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center">
        {t("forgot.heading")}
      </Typography>

      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <TextField
          label={t("forgot.fields.email")}
          name="email"
          size="small"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          fullWidth
          required
        />

        <CaptchaComponent
          onChange={formik.handleChange}
          setCaptchaKey={setCaptchaKey}
        />
        <TextField
          label={t("signin.fields.captcha")}
          name="captcha_value"
          size="small"
          value={formik.values.captcha_value}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.captcha_value && Boolean(formik.errors.captcha_value)
          }
          helperText={formik.touched.captcha_value && formik.errors.captcha_value}
          fullWidth
          required
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? t("forgot.buttons.sending") : t("forgot.buttons.sendOtp")}
        </Button>

        <Typography variant="body2" align="center" sx={{ mt: 1 }}>
          <Link
            underline="hover"
            sx={{ cursor: "pointer" }}
            onClick={onBackToLogin}
          >
            {t("forgot.backToLogin")}
          </Link>
        </Typography>
      </Box>

      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </>
  );
};